import React, { Component } from "react";
import { component_tool } from '@/tool';
import ReactDOM from 'react-dom'
let { WizModal, WizSelect } = component_tool;
import { Table, Form } from "antd";
// let Option = WizSelect.Option
// let OptGroup = WizSelect.OptGroup
const { Option, OptGroup } = WizSelect;
import { WizJointExhibition, WizTableForm } from '@/containers/common'

//配置项
let componentName = 'ruleConfigure'

export default class ActionTypeSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    let { value } = nextProps;
    nextState['value'] = value
    return true;
  }

  onChange = (actionType) => {
    this.setState({
      value: actionType
    }, () => {
      this.props.onChange && this.props.onChange(actionType)
    })
  }

  render() {
    return <WizSelect
      allowClear={true}
      placeholder="请选择行为"
      onChange={(actionType) => { this.onChange(actionType) }}
      value={this.state.value}
    >
      {actionOption}
    </WizSelect>
  }
}

const getActionName = (optionValue) => {
  let returnName = ""
  for (let index = 0; index < actionMapList.length; index++) {
    const action = actionMapList[index];
    returnName = action[`labelName`]
    if (action.optionList && action.optionList instanceof Array) {
      for (let j = 0; j < action.optionList.length; j++) {
        const option = action.optionList[j]
        if (optionValue == option['optionValue']) {
          returnName = returnName + ">" + option['optionName']
          return returnName
        }
      }
    }
  }
}
const actionMapList = [{
  labelName: '平台行为',
  optionList: [
    { optionName: '登录', optionValue: 0 }
    , { optionName: '新手任务', optionValue: 1 }]
}, {
  labelName: '社区行为',
  optionList: [
    { optionName: '发帖', optionValue: 2 },
    { optionName: '点赞', optionValue: 3 },
    { optionName: '评论', optionValue: 4 },
    { optionName: '转发', optionValue: 5 },
    { optionName: '活动任务', optionValue: 6 },
    { optionName: '踩贴', optionValue: 13 },
  ]
}, {
  labelName: '学习行为',
  optionList: [
    { optionName: '课程学习', optionValue: 7 },
    { optionName: '路径学习', optionValue: 8 },
    { optionName: '考试', optionValue: 9 },
    { optionName: '直播', optionValue: 10 },
    { optionName: '班级任务', optionValue: 11 },
    { optionName: '问卷调查', optionValue: 12 },
    { optionName: '路径评语', optionValue: 14 },
    { optionName: '考试通过', optionValue: 15 },
  ]
}]
const actionOption = actionMapList.map(action =>

  <OptGroup label={action['labelName']}>
    {action.optionList && action.optionList instanceof Array && action.optionList.length > 0 ?
      action.optionList.map(option =>
        <Option value={option.optionValue}>{option.optionName}</Option>)
      : null
    }
  </OptGroup>)



//   render :function(){
//     return <>

//   </>
// },
// });
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "ruleName",
    dataIndex: "ruleName",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "行为",
    name: "actionType",
    dataIndex: "actionType",
    searchItem: {
      type: 'diy',
      diy: ActionTypeSelect
    },
  },
  {
    title: "行为",
    name: "actionTypeName",
    dataIndex: "actionTypeName",
    tableItem: {},
  },
  {
    title: "业务类型",
    name: 'bizType',
    dataIndex: 'bizType',
    dict: [
      {code: 0, codeName: '课程'},
      {code: 1, codeName: '考试'},
      {code: 8, codeName: '线下课程'},
      {code: 24, codeName: '帖子'},
      {code: 32, codeName: '路径阶段'},
      {code: 16, codeName: '路径评语'},
    ],
    searchItem: {
      type: 'select'
    }
  },
  {
    title: "业务实体",
    name: 'bizId',
    dataIndex: 'bizId',
    searchItem: {
      type: 'diy',
      diy: WizTableForm,
      links: {'bizType': '业务类型'},
      ...WizTableForm.Config.program(this, {}),
      changePopsFunction: (linksValues) => {
        const {bizType} = linksValues
        let other = {
          selectType: 'radio'
        }
        let config;
        if (bizType === 0) {
          config = WizTableForm.Config.program(this, {})
        } else if (bizType === 1) {
          config = WizTableForm.Config.exam(this, {})
        } else if (bizType === 24) {
          config = WizTableForm.Config.invitation(this, {})
        } else if(bizType === 32) {
          config = WizTableForm.Config.invitation(this, {})
        }else if(bizType === 8) {
          config = WizTableForm.Config.offlineProgram(this, {})
        }else if(bizType === 16) {
          config = WizTableForm.Config.trainPathComment(this, {})
        }
        if (config == null) {
          other.disabled = true;
        }
        let tableFormProps = {
          ...config,
          ...other
        }
        return tableFormProps
      },
    }
  },
  {
    title: "产物类型",
    name: "outputClassName",
    dataIndex: "outputClassName",
    tableItem: {},
  },
  {
    title: "规则受众",
    name: "targetScope",
    dataIndex: "targetScope",
    tableItem: {
      width: 400,
    },
  },

  {
    title: "产物类型",
    name: "outputClass",
    dataIndex: "outputClass",
    dict: [
      { code: 0, codeName: "积分" },
      { code: 1, codeName: "学分" },
      { code: 2, codeName: "证书" },
      { code: 3, codeName: "经验" },
      { code: 4, codeName: "阶段" }
    ],
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: "有效" },
      { code: 0, codeName: "无效" }
    ],
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
  },
  {
    title: "最新修改时间",
    name: "updateTime",
    dataIndex: "updateTime",
    tableItem: {
      width: 200,
    },
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', 'delete'],
        buttons: [

          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/rule/configureList/ruleConfigureDetailAdd'
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },

      rowOperateSort: ['look', 'update', 'enableOrDisable'],
      rowOperateView: [
        {
          key: "update",
          custom: true,
          params: { children: "编辑" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/rule/configureList/ruleConfigureDetailUpd"
            },
          }
        },
        {
          key: "look",
          custom: true,
          params: { children: "查看" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/rule/configureList/look"
            },
          }
        },
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "启用" },
          textFormat: {
            recordKey: 'state',
            dirt: { 1: '禁用', 0: '启用' }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                (record.state === 1 ? "禁用" : "启用")
                }该规则配置吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 1 ? 0 : 1,
                    ids: [record['id']],
                    //...filters
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
      ]
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig, actionOption, getActionName };
